import { languageUtils } from "@/utils/languageUtils";
import type { FindRideTranslations } from "./translations/en";
import { findRideEn } from "./translations/en";
import { findRideTe } from "./translations/te";

export type {
  FindRideTranslations,
  FindRideTranslationKeys,
} from "./translations/en";

const FIND_RIDE_LOCALES: Record<string, FindRideTranslations> = {
  en: findRideEn,
  te: findRideTe,
};

/** Resolve Find Ride copy for the active UI language (English fallback). */
export function loadFindRideTranslations(
  partial?: Partial<FindRideTranslations>
): FindRideTranslations {
  const lang = languageUtils.getCurrentLanguage();
  const locale = FIND_RIDE_LOCALES[lang] ?? findRideEn;
  return { ...findRideEn, ...locale, ...partial };
}

/** @deprecated Prefer resolving via {@link loadFindRideTranslations} / tFindRide. */
export const findRideTranslations = loadFindRideTranslations();
